import { RootState } from '../root.reducers';
import { UtimacoPacketSwitch } from './utimacoPacketSwitch.types';

export const getUtimacoPacketSwitchList = (state: RootState): UtimacoPacketSwitch[] =>
  state.utimacoPacketSwitch.entities;

export const getUtimacoPacketSwitch = (state: RootState): UtimacoPacketSwitch | null =>
  state.utimacoPacketSwitch.single;

export const getSelectedUtimacoPacketSwitch = (state: RootState): UtimacoPacketSwitch[] =>
  state.utimacoPacketSwitch.selected;

export const getUtimacoPacketSwitchCreatedId = (state: RootState): string | null =>
  state.utimacoPacketSwitch.createdId;

export const isUtimacoPacketSwitchCreatePopupOpen = (state: RootState): boolean =>
  state.utimacoPacketSwitch.ui.isCreatePopupOpen;

export const isUtimacoPacketSwitchLoading = (state: RootState): boolean =>
  state.utimacoPacketSwitch.ui.isLoading;
